import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {

   private matTabNavVarVisible$ = new BehaviorSubject<boolean>(true);

  setVisibleMatTabNav(visible: boolean) {
    this.matTabNavVarVisible$.next(visible);
  }

  isVisibleMatTabNav$() {
    return this.matTabNavVarVisible$.asObservable();
  }
}
